<!--
  @description 流程管理-通用工单
  @author xiehan
  @date 2019/02/20
-->
<template>
  <div class="commonRequest">
    <request-note
      ref="requestNote"
      @submitRequest="getRequestForm"
      submitButtonRac="commonRequest@submit"
      :requestTitle="requestTitle"
      :disAgreeInfo="disAgreeInfo"
      :status="status">
      <div slot="center" style="overflow: scroll;">
        <div class="mb-base" :style="tableHeadWidth">
          <div v-for="(val, key) in propertyObj" :key="key" class="common-title" :title="val.name">
            <span style="color: red;" v-if="val.require">*</span>
            <span v-text="val.name"></span>
          </div>
          <el-button icon="icon-xinzeng"
            type="primary"
            style="width: 70px;"
            @click="addPropertyList"></el-button>
        </div>
        <el-form :style="tableHeadWidth" :inline="true" ref="commonForm" :model="commonForm" label-width="0" input-width="120px">
          <div v-for="(item, index) in commonForm.commnonList" :key="index">
            <el-form-item v-for="(val, key) in propertyObj"
              :key="key"
              :prop="'commnonList.' + index + '.' + key"
              :rules="[{ required: val.require, message: $t('common.entryTips') + val.name, trigger: 'blur' }]">
              <el-input v-model="item[key]"></el-input>
            </el-form-item>
            <el-button icon="icon-shanchu1"
              style="width: 70px;"
              @click="deletePropertyList(index)"></el-button>
          </div>
        </el-form>
      </div>
      <div slot="footer">
        <el-table
          v-if="status === '5'"
          :data="processTable"
          style="width: 100%">
          <el-table-column prop="operateTime" :label="$t('common.time')"></el-table-column>
          <el-table-column prop="node" :label="$t('queryworkOrder.node')"></el-table-column>
          <el-table-column prop="operator" :label="$t('queryworkOrder.operator')"></el-table-column>
          <el-table-column prop="operation" :label="$t('common.handle')"></el-table-column>
          <el-table-column prop="advise" :label="$t('queryworkOrder.advise')"></el-table-column>
        </el-table>
      </div>
    </request-note>
  </div>
</template>

<script>
  import dic from '@/components/mixins/dic'
  import requestNote from '@/views/component/requestNote/requestNote'
  import queryworkOrderBiz from '@/logic/workFlow/queryworkOrderBiz'
  import resApplicationBiz from '@/logic/workFlow/resApplicationBiz'
  import workFlowTemplateManageBiz from '@/logic/workFlow/workFlowTemplateManageBiz'
  import TimeFormat from '@/utils/timeFormat'
  export default {
    mixins: [dic],
    data () {
      return {
        select_operate: {},
        commonForm: {
          commnonList: []
        },
        status: '1',
        disAgreeInfo: {},
        processTable: [],
        requestTitle: '',
        tableHeadWidth: {
          width: ''
        },
        propertyObj: {}
      }
    },
    components: {
      requestNote
    },
    methods: {
      async getDic () {
        await Promise.all([
          this.dGetDictionaryByCode('workflowOperationType')
        ])
        if (this.$route.query.status === '5') {
          this.getOrderInfo()
        }
        this.select_operate = { ...this.dDictionary.workflowOperationType }
      },
      setTableHeadWidth () {
        this.tableHeadWidth.width = Object.keys(this.propertyObj).length * 130 + 78 + 'px'
      },
      getTemplateInfo () {
        workFlowTemplateManageBiz.findTemplateById({ id: this.$route.query.templateId }).then(res => {
          this.requestTitle = res.name
          this.propertyObj = {}
          let tempList = []
          let tempObj = {}
          res.propertyList.map(item => {
            tempObj[item.property] = ''
            this.propertyObj[item.property] = {}
            this.propertyObj[item.property]['require'] = item.require
            this.propertyObj[item.property]['name'] = item.name
          })
          tempList.push(tempObj)
          this.commonForm.commnonList = tempList
          this.$refs.commonForm.clearValidate()
          this.setTableHeadWidth()
        })
      },
      getRequestForm (val) {
        this.$refs['commonForm'].validate((valid) => {
          if (valid) {
            let saveInfo = {
              applicant: val.applicant,
              approver: val.approver,
              cc: val.cc,
              department: val.department,
              expectedTime: val.expectedTime,
              businessData: this.commonForm.commnonList,
              orderType: val.orderType,
              processInstanceId: val.processInstanceId,
              templateId: this.$route.query.templateId,
              reason: val.reason,
              remarks: val.remarks,
              site: val.site
            }
            resApplicationBiz.submitCommonApply(saveInfo).then(() => {
              this.$message({
                message: this.$t('common.success'),
                type: 'success'
              })
              this.$router.push({ name: 'cloudApplication' })
            })
          } else {
            return false
          }
        })
      },
      addPropertyList () {
        let obj = {}
        Object.keys(this.propertyObj).map(item => {
          obj[item] = ''
        })
        this.commonForm.commnonList.push(obj)
      },
      deletePropertyList (index) {
        if (this.commonForm.commnonList.length === 1) return
        this.commonForm.commnonList.splice(index, 1)
      },
      getOrderInfo () {
        queryworkOrderBiz.getTaskDetailById({
          processInstanceId: String(this.$route.query.orderId)
        }).then(data => {
          this.disAgreeInfo = data
          this.processTable = data.record
          this.processTable.map(item => {
            item.operateTime = TimeFormat.getFormatTime(item.operateTime)
            item.operation = this.select_operate[item.operation]
          })
          this.commonForm.commnonList = []
          this.disAgreeInfo.info.businessData.map(item => {
            this.commonForm.commnonList.push({ ...item })
          })
          this.$nextTick(() => {
            this.$refs.requestNote.onStatus5()
          })
          this.requestTitle = this.disAgreeInfo.templateInfo.name
          this.propertyObj = {}
          this.disAgreeInfo.templateInfo.propertyList.map(item => {
            this.propertyObj[item.property] = {}
            this.propertyObj[item.property]['require'] = item.require
            this.propertyObj[item.property]['name'] = item.name
          })
          this.$refs.commonForm.clearValidate()
          this.setTableHeadWidth()
        })
      }
    },
    watch: {
      $route (to, from) {
        if (to.name === 'commonRequest' && from.name === 'cloudApplication') {
          this.status = '1'
          this.$nextTick(() => {
            this.$refs.requestNote.init()
          })
          this.getDic()
          this.getTemplateInfo()
        } else if (to.name === 'commonRequest' && from.name === 'queryworkOrder') {
          this.status = '5'
          this.getDic()
        }
      }
    },
    mounted () {
      if (this.$route.query.status === '5') {
        this.status = '5'
      } else {
        this.getTemplateInfo()
      }
      this.getDic()
    }
  }
</script>

<style scoped>
 .common-title {
    width: 120px;
    vertical-align: middle;
    display: inline-block;
    margin-right: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>